
export const Service = [{
    image: require(`../Assets/Card/DiagnozaAuto.jpg`),
    title: 'Diagnoza auto',
    description1: 'Verificare parametri de functionare ai motorului , abs , airbag , directie asistata sa',
    description2: 'Diagnosticare defectiuni',
    description3: "Citire si stergere erori",
    description4: 'Regenerare filtru de particule DPF',

},
{
    image: require('../Assets/Card/SchimbUlei.jpg'),
    title: 'Schimb de ulei',
    description1: 'Ridicare masina: Masina este ridicata pentru a accesa sistemul de ulei si filtrele.',
    description2: 'Inlocuirea filtrului: Se inlocuiesc filtrele de ulei si aer.',
    description3: "Schimbarea uleiului: Uleiul uzat este scurs si inlocuit cu ulei nou.",
    description4: 'Verificarea nivelului: Nivelul de ulei este verificat si ajustat daca este necesar.',

},
{
    image: require('../Assets/Card/SchimbFiltre.jpg'),
    title: 'Schimb Filtre',
    description1: 'Înlocuirea filtrelor este crucială pentru menținerea performanței și eficienței mașinii.',
    description2: 'Aceasta prelungește durata de viață a motorului și a altor componente.',
    description3: "Schimbarea filtrelor ajută la îmbunătățirea calității aerului și a combustibilului.",
    description4: 'Filtrele proaspete reduc riscul de daune costisitoare la mașină și previn defecțiunile mecanice.',


},
{
    image: require('../Assets/Card/IncarcareFreon.jpg'),
    title: 'Incarcare AC/Curatare instalatie AC',
    description1: 'Consultanta de specialitate',
    description2: 'Curatarea si vidarea instalatiei folosind aparatura profesionala',
    description3: "Incarcare Freon Auto in instalatia de aer conditionat a masinii",
    description4: 'Un serviciu profesional realizat cu aparatura specializata, recomandat pentru orice tip de masina care nu prezinta defecte mecanice la instalatia de aer conditionat sau scurgeri de Freon Auto!',

},
{
    image: require('../Assets/Card/MecanicaAuto.jpg'),
    title: 'Mecanica Auto',
    description1: 'Diagnosticarea problemei: Se identifica problema din motor.',
    description2: 'Repararea motorului: Se repara motorul, inlocuind piesele defecte.',
    description3: "Testarea functionarii: Motorul este testat pentru a verifica functionarea corecta.",
    description4: 'Verificarea performantei: Performantele motorului sunt verificate si ajustate daca este necesar.',

},
{
    image: require('../Assets/Card/SchimbDistributie.jpg'),
    title: 'Schimb kit Distributie',
    description1: 'Diagnosticarea problemei: Identificarea cauzei problemei din sistemul de distributie.',
    description2: 'Achizitionarea pieselor necesare: Comandarea pieselor necesare pentru inlocuirea componentelor deteriorate.',
    description3: "Demontarea si inlocuirea componentelor: Demontarea componentelor defecte si inlocuirea acestora cu cele noi.",
    description4: 'Verificarea si testarea: Verificarea functionarii corecte a sistemului de distributie si testarea masinii pentru a se asigura ca totul functioneaza corect.',

},
{
    image: require('../Assets/Card/SchimbAmbreiaj.jpg'),
    title: 'Schimb kit Ambreiaj',
    description1: 'Accesul la sistem: Se acceseaza sistemul de ambreiaj.',
    description3: "Asamblarea: Componentele sunt asamblate la loc.",
    description2: "Inlocuirea componentelor: Se inlocuiesc discurile, placutele si rulmentii de ambreiaj.",
    description4: 'Testare: Se testeaza functionarea sistemului de ambreiaj. '

},
{
    image: require('../Assets/Card/SchimbFrane.jpg'),
    title: 'Schimb elemente franare',
    description1: 'Identificarea problemei: Se identifica problema din sistemul de franare.',
    description2: 'Inlocuirea componentelor: Se inlocuiesc placutele si discurile de frana, precum si lichidul de frana.',
    description3: "Testarea functionarii: Se testeaza functionarea sistemului de franare.",
    description4: 'Verificarea presiunii: Presiunea din sistemul de franare este verificata si ajustata daca este necesar.',

},
{
    image: require('../Assets/Card/GeometrieRoti.jpg'),
    title: 'Geometrie roti 3D',
    description1: 'Geometria roților asigură o direcție corectă și o stabilitate optimă a mașinii.',
    description2: 'Acesta prelungește durata de viață a anvelopelor și a altor componente.',
    description3: "Geometria corectă reduce consumul de combustibil și minimizează uzura neuniformă a anvelopelor.",
    description4: 'O geometrie corectă reduce riscul de accidente și menține siguranța pe drum.',

},

]